import { toggleClass, toggleAttr, ready } from './helpers.js';
import { slideUp, slideToggle } from './modules/slideToggle';
import GridSlider from './modules/GridSlider';
import AnimateOnScroll from './modules/AnimateOnScroll.js';
import FullscreenElements from './modules/FullscreenElements';
import TestimonialCarousel from './modules/TestimonialCarousel.js';
import { ParallaxElements, ParallaxBackgrounds } from './modules/Parallax';

/**
 * Toggle the menu
 * 
 */

class ToggleMenu {
    constructor(toggles, menu) {
        this.menu = menu;
        if (toggles.length) {
            for (let i = 0; i < toggles.length; i++) {
                toggles[i].addEventListener('click', (e) => this.toggle(e));
            }
        }
        // submenus
        this.submenus = menu.querySelectorAll('.menu-item-has-children > a');
        if (this.submenus.length) {
            for (let i = 0; i < this.submenus.length; i++) {
                this.submenus[i].addEventListener('click', (e) => this.toggleSubmenu(e));
            }
        }
    }

    toggle(e) {

        toggleClass(e.target, 'toggled');
        toggleClass(document.body, 'menu-toggled');
        toggleAttr(e.target, 'aria-expanded');
    }

    toggleSubmenu(e) {
        e.preventDefault();
        const submenu = e.target.parentNode.querySelector('.sub-menu');
        if (!submenu) {
            return;
        }

        const openMenuParents = this.menu.querySelectorAll('.menu-parent-opened');
        const openSubmenus = this.menu.querySelectorAll('.menu-opened');
        
        if (e.target.parentNode.parentNode.classList.contains('menu') && openMenuParents && openSubmenus) {
            for (let i = 0; i < openMenuParents.length; i++) {
                slideUp(openSubmenus[i]);
                openMenuParents[i].classList.remove('menu-parent-opened');
                openSubmenus[i].classList.remove('menu-opened');
            }
        }
        slideToggle(submenu);
        toggleClass(e.target.parentNode, 'menu-parent-opened');
        toggleClass(submenu, 'menu-opened');
    }

}
new ToggleMenu(document.getElementsByClassName('menu-toggle'), document.querySelector('.main-navigation'));

/**
 * Setup Fullscreen Elements
 */

const slideElements = new FullscreenElements(document.querySelectorAll('.swiper-container'));

/**
 * Make the header sticky
 * 
 * 
 */

class StickyHeader {
    constructor(header) {
        if (header) {
            this.header = header;
            window.addEventListener('scroll', (e) => this.stick(e));
        }
    }
    stick(e) {
        const sticky = this.header.offsetHeight;
        const scrolled = window.pageYOffset || document.body.scrollTop;

        if (scrolled > sticky) {
            document.body.classList.add('sticky');
        } else {
            document.body.classList.remove('sticky');
        }
    };
}

new StickyHeader(document.querySelector('.swiper-container'));
new StickyHeader(document.querySelector('.header-background'));
new StickyHeader(document.querySelector('.header-nobackground'));

/**
 * Responsive background images
 * 
 * 
 */

class ResponsiveBackgroundImage {

    constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';
        
        if (!this.img) {
            return;
        }
        this.img.setAttribute('loading', false);
        this.img.addEventListener('load', () => {
            this.img.style.display = 'none';
            this.update();
        });

        if (this.img.complete) {
            this.img.style.display = 'none';
            this.update();
        }
    }

    update() {
        let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
        if (this.src !== src) {
            this.src = src;
            this.element.style.backgroundImage = 'url("' + this.src + '")';
        }
    }
}

const setupResponsiveBackgrounds = () => {
    let elements = document.querySelectorAll('[data-responsive-background-image]');
    for (let i = 0; i < elements.length; i++) {
        new ResponsiveBackgroundImage(elements[i]);
    }
}
ready().then(() => {
    setupResponsiveBackgrounds();
});

ready().then(() => {
    new ParallaxElements(document.getElementsByClassName('parallax-element'));
    new ParallaxBackgrounds(document.getElementsByClassName('parallax-background'));
});

/**
 * Modal for images and other content
 * 
 */

class Modal {
    constructor(els) {
        // Setup properties
        this.modal;
        this.currentEl;

        // Init modal element
        this.modal = document.createElement('div');
        this.modal.id = 'ne-modal';
        this.modal.classList.add('d-none');
        this.modal.classList.add('ne-modal__wrapper');
        document.body.appendChild(this.modal);

        // Add event listeners
        if (els.length) {
            for (let i = 0; i < els.length; i++) {
                els[i].addEventListener('click', (e) => this.openModal(e));
            }
        }
    }

    openModal(e) {
        toggleClass(document.body, 'ne-modal-open');
        this.currentEl = e.target;
        this.createModal(this.currentEl);
        this.modal.innerHTML = '';
        this.modal.appendChild(el.cloneNode(true));

        // If caption is set on attribute, or if title is set
        const caption = el.getAttribute('alt') || el.getAttribute('title');
        if (caption) {
            this.modal.innerHTML += `<div class="ne-modal__caption"><p>${caption}</p></div>`;
        }

        this.modal.classList.remove('d-none');
    }
    closeModal() {
        this.modal.classListadd('d-none');
    }

}

new Modal(document.getElementsByClassName('ne-modal'));


// app

/**
 * Initialise Grid sliders
 * 
 */
const gridSliders = document.querySelectorAll('.wp-block-ne-gutenberg-blocks-image-grid ');

if (gridSliders) {
    for (let i = 0; i < gridSliders.length; i++) {
        new GridSlider(gridSliders[i]);
    }
}

/**
 * Initalise Animate on Scroll
 * 
 */

const animateOnScroll = document.querySelectorAll('.animate-on-scroll-element');

if (animateOnScroll) {
    for (let i = 0; i < animateOnScroll.length; i++) {
        new AnimateOnScroll(animateOnScroll[i]);
    }
}

/**
 * Initalise Animate on Scroll
 * 
 */

const testimonials = document.querySelectorAll('.testimonial-carousel');

if (testimonials) {
    for (let i = 0; i < testimonials.length; i++) {
        new TestimonialCarousel(testimonials[i]);
    }
}

